import request from '@utils/request';
import { useQuery } from '@tanstack/react-query';
import { SpaClassesPage } from '@features/spa/spa.types';

export const spaClassesPageKeys = {
  spaClassesPage: ['spaClassesPage'] as const,
  spaClassesPageKey: (propertyId: number, language: string) =>
    [...spaClassesPageKeys.spaClassesPage, propertyId, language] as const,
};

export function useGetSpaClassesPage(propertyId: number, language = 'en') {
  return useQuery({
    queryKey: spaClassesPageKeys.spaClassesPageKey(propertyId, language),
    queryFn: () => getSpaClassesPage(propertyId, language),
  });
}

async function getSpaClassesPage(propertyId: number, language: string) {
  const { data } = await request.get(`${propertyId}/pages/spa-classes/${language}`);
  return data as SpaClassesPage;
}
